const anchorsTabsInit = () => {
    const anchorTabsList = document.querySelectorAll('.anchors-tabs-block-acf');
    if (!anchorTabsList) {
        return;
    }
    anchorTabsList.forEach((tabsItem) => {
        const tabLabelList = tabsItem.querySelectorAll('.single-tab-label');
        const tabPanelLists = tabsItem.querySelectorAll('.single-tab-panel');
        const anchorLinkList = tabsItem.querySelectorAll('.anchors-tabs__link');
        if (anchorLinkList && anchorLinkList[0] && anchorLinkList[0] instanceof HTMLElement) {
            anchorLinkList[0].classList.add('activ');
        }
        if (tabLabelList.length > 0) {
            tabLabelList.forEach((tabLabelItem, index) => {
                if (index === 0) {
                    tabLabelList[0].classList.add('activ');
                }
                if (tabLabelItem instanceof HTMLElement) {
                    tabLabelItem.setAttribute('data-tab-index', index.toString(10));
                }
            });
        }
        if (tabPanelLists[0] && tabPanelLists[0] instanceof HTMLElement) {
            tabPanelLists[0].classList.add('activ');
        }
        if (tabsItem instanceof HTMLElement) {
            tabsItem.style.display = 'block';
        }
        anchorLinkList.forEach((link) => {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                const parentTab = link.closest('.single-tab-label');
                if (event.target instanceof HTMLAnchorElement) {
                    let url = new URL(event.target.href);
                    let hash = url === null || url === void 0 ? void 0 : url.hash;
                    const target = event.target.getAttribute('target');
                    if (hash) {
                        hash = hash.replace('#', '');
                        const element = document.getElementById(hash);
                        if (parentTab && parentTab instanceof HTMLElement && !parentTab.classList.contains('activ')) {
                            tabLabelList.forEach((item) => {
                                item.classList.remove('activ');
                            });
                            parentTab.classList.add('activ');
                            const index = parentTab.dataset.tabIndex;
                            tabPanelLists.forEach((item) => {
                                item.classList.remove('activ');
                            });
                            if (index) {
                                tabPanelLists[index].classList.add('activ');
                            }
                        }
                        anchorLinkList.forEach((link) => {
                            link.classList.remove('activ');
                        });
                        if (event.target instanceof HTMLElement) {
                            event.target.classList.add('activ');
                        }
                        if (element instanceof HTMLElement) {
                            element.scrollIntoView();
                        }
                    }
                    else {
                        if (target && target === '__blank') {
                            window.open(event.target.href, target);
                        }
                        else {
                            window.location.href = event.target.href;
                        }
                    }
                }
            });
        });
    });
};
export default anchorsTabsInit;
